import { TournamentFollow } from '../models';
import { TournamentFollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class FollowTournamentUseCase {
  constructor(private tournamentFollowRepository: TournamentFollowRepository) {}

  async execute(userId: string, tournamentId: string): Promise<TournamentFollow> {
    logger.debug('FollowTournament', 'Following tournament', { userId, tournamentId });

    // Check if already following
    const isFollowing = await this.tournamentFollowRepository.isFollowing(userId, tournamentId);
    if (isFollowing) {
      throw new Error('Already following this tournament');
    }

    const follow = await this.tournamentFollowRepository.follow(userId, tournamentId);

    logger.debug('FollowTournament', 'Successfully followed tournament');

    return follow;
  }
}
